import { UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PopularPlace.css';

export type TPopularPlace = {
  title: string;
  text: string;
  imageUrl: string;
  url: string;
  urlPart: string;
  analyticsLabel: string;
};

type TPopularPlaceProps = {
  place: TPopularPlace;
  onClick(): void;
};

export function PopularPlace({ place: { imageUrl, title, text }, onClick }: TPopularPlaceProps) {
  return (
    <li className={styles['place']} onClick={onClick}>
      <div className={styles['content']}>
        <UIHeading5 as="h4">{title}</UIHeading5>
        <UIText2 color="gray60_100">{text}</UIText2>
      </div>
      <img src={imageUrl} width="120" height="88" />
    </li>
  );
}
